import React from 'react';
import {Divider} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowAltCircleRight, faArrowRight} from "@fortawesome/free-solid-svg-icons";

const AgencyHours = ({availabilities, agencyOperatingHours, mode, closingPeriodItems}) => {
    const hasClosingPeriods = closingPeriodItems?.length > 0;
    const showOpeningHoursTitle =
        (availabilities?.length > 0 && availabilities[0].status !== 'unavailable') || hasClosingPeriods;

    return (
        <div className={"mt-2"}>
            {!agencyOperatingHours && (
                <>
                    {showOpeningHoursTitle && <p className={"text-center"}>Horaires d'ouverture</p>}
                    <Divider />
                    {availabilities?.map(item => (
                        <div key={`agency_open_hour_${item.day}_${item.start_hour}`} className={"d-flex flex-row justify-content-center align-items-center"}>
                            {item.start_hour === "00:00" && item.end_hour === "23:59" ? (
                                item.status === 'unavailable' ? (
                                    <p className={"my-1"}>Fermé</p>
                                ) : (
                                    <p className={"my-1"}>Ouvert toute la journée</p>
                                )
                            ) : (
                                <>
                                    <p className={"medium px-2 bradius-5"}>{item.start_hour}</p>
                                    <p className={"mx-2 fs14"}><FontAwesomeIcon icon={faArrowAltCircleRight} /></p>
                                    <p className={"medium px-2 bradius-5"}>{item.end_hour}</p>
                                </>
                            )}
                        </div>
                    ))}
                    {closingPeriodItems?.map((item, index) => (
                        <div
                            key={`agency_closing_period_${item.start_hour}_${item.end_hour}_${index}`}
                            className={"d-flex flex-row justify-content-center align-items-center"}
                        >
                            <p className={"my-1 fst-italic"}>Fermeture exceptionnelle</p>
                            <p className={"medium px-2 bradius-5 ms-2"}>{item.start_hour}</p>
                            <p className={"mx-2 fs14"}><FontAwesomeIcon icon={faArrowAltCircleRight} /></p>
                            <p className={"medium px-2 bradius-5"}>{item.end_hour}</p>
                        </div>
                    ))}
                </>
            )}
            {agencyOperatingHours?.length > 0 && availabilities?.length > 0 && availabilities[0].status !== 'unavailable' && (
                <>
                    <p className={"text-center"}>Horaires de {mode === "start" ? "départ" : "retour"} autorisés</p>
                    <Divider />
                    {agencyOperatingHours.map(item => (
                        <div key={`agency_operating_hour_${item.day}_${item.min_hour}`} className={"d-flex flex-row justify-content-center align-items-center"}>
                            {item.min_hour === "00:00" && item.max_hour === "23:59" ? (
                                <>Toute la journée</>
                            ) : (
                                <>
                                    <p className={"medium px-2 bradius-5"}>{item.min_hour}</p>
                                    <p className={"mx-2 fs14"}><FontAwesomeIcon icon={faArrowRight} /></p>
                                    <p className={"medium px-2 bradius-5"}>{item.max_hour}</p>
                                </>
                            )}
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default AgencyHours;
